module.exports = __webpack_public_path__ + "static/fictionGif-3b22699bed764948966544454bfba37e.mp4";